<template>
    <div class="proc-etapa-edit form-panel">
        <div class="form-panel-header">
            Detalhes da Etapa
        </div>

        <div class="form-panel-body">
            <div class="row row-space">
                <div class="form-item-char10">
                    <label class="label-caption">Ordem</label>
                    <input type="number" v-model.number="etapaLocal.ordem" @input="aplicarAlteracao" />
                </div>

                <div class="form-item-char20">
                    <label class="label-caption">Código</label>
                    <input type="text" v-model="etapaLocal.cdetapa" maxlength="30" @input="aplicarAlteracao" />
                </div>

                <div class="form-item">
                    <label class="label-caption">Nome da Etapa</label>
                    <input type="text" v-model="etapaLocal.nmetapa" maxlength="100" @input="aplicarAlteracao" />
                </div>

                <div class="form-item-char10">
                    <label class="label-caption">Prazo</label>
                    <input type="number" v-model.number="etapaLocal.prazo_dias" @input="aplicarAlteracao" />
                </div>

                <button v-show="etapaLocal.id" type="button" class="btn-small" @click="showModalPerfil = true">
                    Perfil
                </button>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Descrição</label>
                    <textarea v-model="etapaLocal.descricao" rows="3" @input="aplicarAlteracao" />
                </div>
            </div>

            <div class="proc-check-grid row-space">
                <label><input type="checkbox" v-model="ckInicial" /> Inicial</label>
                <label><input type="checkbox" v-model="ckFinal" /> Final</label>
                <label><input type="checkbox" v-model="ckExigeAprovacao" /> Exige Aprovação</label>
                <label><input type="checkbox" v-model="ckPermiteRetorno" /> Permite Retorno</label>
                <label><input type="checkbox" v-model="ckPermiteAnexo" /> Permite Anexo</label>
                <label><input type="checkbox" v-model="ckPermiteDoc" /> Permite Documento</label>
                <label><input type="checkbox" v-model="ckPermiteAssinatura" /> Permite Assinatura</label>
            </div>

            <div class="row row-space">
                <div class="form-item">
                    <label class="label-caption">Etapa ao Aprovar</label>
                    <select v-model.number="etapaLocal.id_etapa_aprovada" @change="aplicarAlteracao">
                        <option :value="0">Nenhuma</option>
                        <option
                            v-for="e in etapasDisponiveis"
                            :key="`aprov-${e._uid || e.id}`"
                            :value="e.id"
                        >
                            {{ e.ordem }} - {{ e.nmetapa }}
                        </option>
                    </select>
                </div>

                <div class="form-item">
                    <label class="label-caption">Etapa ao Reprovar</label>
                    <select v-model.number="etapaLocal.id_etapa_reprovada" @change="aplicarAlteracao">
                        <option :value="0">Nenhuma</option>
                        <option
                            v-for="e in etapasDisponiveis"
                            :key="`reprov-${e._uid || e.id}`"
                            :value="e.id"
                        >
                            {{ e.ordem }} - {{ e.nmetapa }}
                        </option>
                    </select>
                </div>
            </div>

            <div class="proc-vinculos-grid">
                <section class="proc-vinculo-box">
                    <div class="proc-vinculo-header">
                        <strong>Modelos vinculados</strong>
                        <button type="button" class="btn-small" @click="showModalEpDoc = true">
                            Vincular
                        </button>
                    </div>

                    <div v-if="epDocsVisiveis.length === 0" class="info-empty">
                        Nenhum modelo vinculado.
                    </div>

                    <div
                        v-for="item in epDocsVisiveis"
                        :key="item._uid || item.id"
                        class="proc-vinculo-card"
                    >
                        <div class="proc-vinculo-title">
                            {{ nomeEpDoc(item.idepdocmodelo) }}
                            <button
                                type="button"
                                class="btn-icon--trash proc-icon-btn"
                                @click="removerEpDoc(item)"
                            />
                        </div>

                        <div class="proc-check-grid proc-check-grid--small">
                            <label><input type="checkbox" v-model="boolEpDoc(item).ckobrigatorio" /> Obrigatório</label>
                            <label><input type="checkbox" v-model="boolEpDoc(item).ckpermite_multiplos" /> Múltiplos</label>
                            <label><input type="checkbox" v-model="boolEpDoc(item).ckexige_assinatura" /> Assinatura</label>
                            <label><input type="checkbox" v-model="boolEpDoc(item).ckgera_anexo_pdf" /> Gera PDF</label>
                        </div>

                        <textarea
                            v-model="item.instrucoes"
                            rows="2"
                            placeholder="Instruções"
                            @input="aplicarAlteracaoItem(item)"
                        />
                    </div>
                </section>

                <section class="proc-vinculo-box">
                    <div class="proc-vinculo-header">
                        <strong>Tipos de anexos vinculados</strong>
                        <button type="button" class="btn-small" @click="showModalTpDoc = true">
                            Vincular
                        </button>
                    </div>

                    <div v-if="tpDocsVisiveis.length === 0" class="info-empty">
                        Nenhum tipo de anexo vinculado.
                    </div>

                    <div
                        v-for="item in tpDocsVisiveis"
                        :key="item._uid || item.id"
                        class="proc-vinculo-card"
                    >
                        <div class="proc-vinculo-title">
                            {{ nomeTpDoc(item.idtpdoc) }}
                            <button
                                type="button"
                                class="btn-icon--trash proc-icon-btn"
                                @click="removerTpDoc(item)"
                            />
                        </div>

                        <div class="proc-check-grid proc-check-grid--small">
                            <label><input type="checkbox" v-model="boolTpDoc(item).ckobrigatorio" /> Obrigatório</label>
                            <label><input type="checkbox" v-model="boolTpDoc(item).ckpermite_multiplos" /> Múltiplos</label>
                            <label><input type="checkbox" v-model="boolTpDoc(item).ckexige_analise" /> Exige Análise</label>
                        </div>

                        <textarea
                            v-model="item.instrucoes"
                            rows="2"
                            placeholder="Instruções"
                            @input="aplicarAlteracaoItem(item)"
                        />
                    </div>
                </section>
            </div>
        </div>

        <ModalVincularEpDoc
            v-if="showModalEpDoc"
            :lista="lsEpDocModelo"
            :vinculados="etapaLocal.lsEpDoc || []"
            @close="showModalEpDoc = false"
            @confirm="vincularEpDoc"
        />

        <ModalVincularPerfil
            v-if="showModalPerfil"
            :idEtapa="etapaLocal.id"
            :nmEtapa="etapaLocal.nmetapa"
            @close="showModalPerfil = false"
        />

        <ModalVincularTpDoc
            v-if="showModalTpDoc"
            :lista="lsTpDoc"
            :vinculados="etapaLocal.lsTpDoc || []"
            @close="showModalTpDoc = false"
            @confirm="vincularTpDoc"
        />
    </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';
import ModalVincularEpDoc from './ModalVincularEpDoc.vue';
import ModalVincularPerfil from './ModalVincularPerfil.vue';
import ModalVincularTpDoc from './ModalVincularTpDoc.vue';

const emit = defineEmits(['update:etapa']);

const props = defineProps({
    etapa: {
        type: Object,
        required: true
    },
    etapas: {
        type: Array,
        required: true
    },
    lsEpDocModelo: {
        type: Array,
        required: true
    },
    lsTpDoc: {
        type: Array,
        required: true
    }
});

const etapaLocal = ref(criarCopiaEtapa(props.etapa));
const showModalEpDoc = ref(false);
const showModalPerfil = ref(false);
const showModalTpDoc = ref(false);

watch(
    () => props.etapa,
    (nova) => {
        etapaLocal.value = criarCopiaEtapa(nova);
    },
    { immediate: true }
);

const etapasDisponiveis = computed(() =>
    props.etapas.filter(e =>
        e.ativo !== 'N' &&
        !mesmaEtapa(e, etapaLocal.value) &&
        Number(e.id || 0) > 0
    )
);

const epDocsVisiveis = computed(() =>
    (etapaLocal.value.lsEpDoc || []).filter(x => x.ativo !== 'N')
);

const tpDocsVisiveis = computed(() =>
    (etapaLocal.value.lsTpDoc || []).filter(x => x.ativo !== 'N')
);

const ckInicial = snComputed('ckinicial');
const ckFinal = snComputed('ckfinal');
const ckExigeAprovacao = snComputed('ckexige_aprovacao');
const ckPermiteRetorno = snComputed('ckpermite_retorno');
const ckPermiteAnexo = snComputed('ckpermite_anexo');
const ckPermiteDoc = snComputed('ckpermite_doc');
const ckPermiteAssinatura = snComputed('ckpermite_assinatura');

function criarCopiaEtapa(etapa) {
    const copia = JSON.parse(JSON.stringify(etapa || {}));

    copia.lsEpDoc = (copia.lsEpDoc || []).map(x => ({
        ...x,
        _uid: x._uid || gerarUid()
    }));

    copia.lsTpDoc = (copia.lsTpDoc || []).map(x => ({
        ...x,
        _uid: x._uid || gerarUid()
    }));

    copia._uid = copia._uid || gerarUid();

    return copia;
}

function gerarUid() {
    return `uid-${Date.now()}-${Math.random().toString(16).slice(2)}`;
}

function mesmaEtapa(a, b) {
    if (!a || !b) return false;

    if (Number(a.id || 0) > 0 && Number(b.id || 0) > 0) {
        return Number(a.id) === Number(b.id);
    }

    return a._uid && b._uid && a._uid === b._uid;
}

function marcarEtapaAlterada() {
    if (etapaLocal.value._status !== 'insert') {
        etapaLocal.value._status = 'update';
    }
}

function marcarItemAlterado(item) {
    if (item._status !== 'insert') {
        item._status = 'update';
    }
}

function aplicarAlteracao() {
    marcarEtapaAlterada();
    emitirEtapa();
}

function aplicarAlteracaoItem(item) {
    marcarItemAlterado(item);
    marcarEtapaAlterada();
    emitirEtapa();
}

function emitirEtapa() {
    emit('update:etapa', JSON.parse(JSON.stringify(etapaLocal.value)));
}

function snComputed(campo) {
    return computed({
        get: () => etapaLocal.value[campo] === 'S',
        set: value => {
            etapaLocal.value[campo] = value ? 'S' : 'N';
            aplicarAlteracao();
        }
    });
}

function boolEpDoc(item) {
    return {
        get ckobrigatorio() {
            return item.ckobrigatorio === 'S';
        },
        set ckobrigatorio(v) {
            item.ckobrigatorio = v ? 'S' : 'N';
            aplicarAlteracaoItem(item);
        },

        get ckpermite_multiplos() {
            return item.ckpermite_multiplos === 'S';
        },
        set ckpermite_multiplos(v) {
            item.ckpermite_multiplos = v ? 'S' : 'N';
            aplicarAlteracaoItem(item);
        },

        get ckexige_assinatura() {
            return item.ckexige_assinatura === 'S';
        },
        set ckexige_assinatura(v) {
            item.ckexige_assinatura = v ? 'S' : 'N';
            aplicarAlteracaoItem(item);
        },

        get ckgera_anexo_pdf() {
            return item.ckgera_anexo_pdf === 'S';
        },
        set ckgera_anexo_pdf(v) {
            item.ckgera_anexo_pdf = v ? 'S' : 'N';
            aplicarAlteracaoItem(item);
        }
    };
}

function boolTpDoc(item) {
    return {
        get ckobrigatorio() {
            return item.ckobrigatorio === 'S';
        },
        set ckobrigatorio(v) {
            item.ckobrigatorio = v ? 'S' : 'N';
            aplicarAlteracaoItem(item);
        },

        get ckpermite_multiplos() {
            return item.ckpermite_multiplos === 'S';
        },
        set ckpermite_multiplos(v) {
            item.ckpermite_multiplos = v ? 'S' : 'N';
            aplicarAlteracaoItem(item);
        },

        get ckexige_analise() {
            return item.ckexige_analise === 'S';
        },
        set ckexige_analise(v) {
            item.ckexige_analise = v ? 'S' : 'N';
            aplicarAlteracaoItem(item);
        }
    };
}

function vincularEpDoc(modelo) {
    if (!etapaLocal.value.lsEpDoc) etapaLocal.value.lsEpDoc = [];

    etapaLocal.value.lsEpDoc.push({
        id: 0,
        idproc_modelo_etapa: etapaLocal.value.id || 0,
        idepdocmodelo: modelo.id,
        ordem: etapaLocal.value.lsEpDoc.length + 1,
        ckobrigatorio: 'N',
        ckpermite_multiplos: 'N',
        ckexige_assinatura: 'N',
        ckgera_anexo_pdf: 'N',
        instrucoes: '',
        ativo: 'S',
        _status: 'insert',
        _uid: gerarUid(),
        _modelo: modelo
    });

    showModalEpDoc.value = false;
    aplicarAlteracao();
}

function vincularTpDoc(tpdoc) {
    if (!etapaLocal.value.lsTpDoc) etapaLocal.value.lsTpDoc = [];

    etapaLocal.value.lsTpDoc.push({
        id: 0,
        idproc_modelo_etapa: etapaLocal.value.id || 0,
        idtpdoc: tpdoc.id,
        ordem: etapaLocal.value.lsTpDoc.length + 1,
        ckobrigatorio: tpdoc.ckobrigatorio || 'N',
        ckpermite_multiplos: 'N',
        ckexige_analise: 'S',
        instrucoes: '',
        ativo: 'S',
        _status: 'insert',
        _uid: gerarUid(),
        _tpdoc: tpdoc
    });

    showModalTpDoc.value = false;
    aplicarAlteracao();
}

function removerEpDoc(item) {
    const lista = etapaLocal.value.lsEpDoc || [];

    if (Number(item.id || 0) > 0) {
        item.ativo = 'N';
        aplicarAlteracaoItem(item);
    } else {
        etapaLocal.value.lsEpDoc = lista.filter(x => x._uid !== item._uid);
        aplicarAlteracao();
    }
}

function removerTpDoc(item) {
    const lista = etapaLocal.value.lsTpDoc || [];

    if (Number(item.id || 0) > 0) {
        item.ativo = 'N';
        aplicarAlteracaoItem(item);
    } else {
        etapaLocal.value.lsTpDoc = lista.filter(x => x._uid !== item._uid);
        aplicarAlteracao();
    }
}

function nomeEpDoc(id) {
    return props.lsEpDocModelo.find(x => Number(x.id) === Number(id))?.nmepdocmodelo || `Modelo ${id}`;
}

function nomeTpDoc(id) {
    return props.lsTpDoc.find(x => Number(x.id) === Number(id))?.nmtpdoc || `Tipo ${id}`;
}
</script>